module.exports = __webpack_public_path__ + "img/attendance_1.278ab0cf.png";